/**
 * PageLoading — THE full-page/area loading state.
 *
 * One spinner, one label, themed by tokens, used by every page-level
 * loading gate (classes, models, links, doc props, symbols, workspace
 * settings, the projects view gate, the route Suspense fallback, the
 * overview cover). Each page used to hand-roll its own spinner class —
 * classes-spinner, models-spinner, docprops-spinner… — and they had
 * already drifted in size, colour and label. Section-level "Loading…"
 * rows inside widgets are NOT this; this is for a page or a page's main
 * area.
 *
 * `fullPage` paints its own app-surface background and fills the
 * viewport — for when the loader IS the whole route (nothing else has
 * painted a surface behind it). Without it, the loader is transparent
 * and stretches to fill whatever flex area the host gives it.
 */
import './PageLoading.css';

export default function PageLoading({ label = 'Loading', fullPage = false }) {
  return (
    <div
      className={`pidly-page-loading${fullPage ? ' pidly-page-loading--page' : ''}`}
      role="status"
      aria-live="polite"
    >
      <span className="pidly-page-loading-spin" aria-hidden="true" />
      <span className="pidly-page-loading-label">{label}</span>
    </div>
  );
}
